import {
    HORSE_RACE_UPDATE_SUBSCRIBE,
    HORSE_RACE_UPDATE_SUBSCRIBE_ERROR,
    HORSE_RACE_UPDATE_SUBSCRIBED,
    HORSE_RACE_UPDATE_UNSUBSCRIBE,
    HORSE_RACE_UPDATE_UNSUBSCRIBE_ERROR,
    HORSE_RACE_UPDATE_UNSUBSCRIBE_SUCCESS,
    HORSE_RACE_UPDATE_RECEIVED,
    HORSE_RACE_UPDATE_RECEIVE_ERROR,
    HORSE_RACE_UPDATE_CONNECT_ERROR,
    HORSE_RACE_UPDATE_CONNECT,
    HORSE_RACE_UPDATE_FALLBACK_TO_POLLING,
    HORSE_RACE_UPDATE_DISCONNECTED,
    HORSE_RACE_UPDATE_DISCONNECTING
} from '../actions/raceUpdate';
import {APPBRIDGE_SLEEP} from '../../Common/reducers/skysso';

const DEFAULT_COUNTRY_GROUPS = ['+'];
const QUALITY_OF_SERVICE = 0;
const MAX_CONNECTION_ATTEMPTS = 5;
const RECONNECT_DELAY = 1000;

export default function RaceUpdate(config, apiClient, mqttClient, hasFeature) {

    const notificationTopic = config.wss.topic.hrFastResults
    const { connect, subscribe, unsubscribe, closeClient } = mqttClient

    const fetchFrWssDetailsFromApi = getWssDetailsFromApi(apiClient, config.api.common.wssUrl)

    //return middleware funcs 
    return { 
        connectToRaceUpdates, 
        unsubscribeFromRaceUpdates, 
        subscribeToRaceUpdates, 
        failedRaceUpdateConnection 
    }

    //create new connection to client
    function connectToRaceUpdates(store, next, action) {
        if (hasFeature("push-fast-results") && action.type === HORSE_RACE_UPDATE_CONNECT) {
            const newMessageHandler = (topic, message) => {
                
                try {
                    const messageItem = JSON.parse(message.toString());
                    return next({type: HORSE_RACE_UPDATE_RECEIVED, data: messageItem})
                } catch(e) {
                    return next({type: HORSE_RACE_UPDATE_RECEIVE_ERROR, error: e.message})
                }
            }
    
            const disconnectAction = (err) => {
                const state = store.getState();
    
                if (state.horseRacing.raceUpdate.intentionalMqttClose) {
                    return next(action);
                }
    
                if (err) {
                    const failedCount = state.horseRacing.raceUpdate.failedSubscriptionAttempts + 1;
                    return next({type: HORSE_RACE_UPDATE_CONNECT_ERROR, err, failedCount});
                } 
                
                store.dispatch({type: HORSE_RACE_UPDATE_CONNECT});            
            }
            // get fresh details from api (true arg forces refresh of details)
            fetchFrWssDetailsFromApi(true)
                .then(wssDetails => {
                    const { topic, wssUrl } = wssDetails
                    connect(
                        Buffer.from(wssUrl, 'base64').toString('ascii'),
                        newMessageHandler,
                        disconnectAction
                    )
                    return topic
                })
                .then(topic => {
                    //subscribe to topic
                    const parsedTopics = createTopicPaths(action.countryGroups, topic);
                    return subscribe(parsedTopics, QUALITY_OF_SERVICE);
                })
                .then(confirmed => {
                    const confirmedTopics = confirmed.map(c => c.topic);
                    return next({type: HORSE_RACE_UPDATE_SUBSCRIBED, data: confirmedTopics});
                })
                .catch(error => {
                    const failedCount = store.getState().horseRacing.raceUpdate.failedSubscriptionAttempts + 1;
                    return next({type: HORSE_RACE_UPDATE_CONNECT_ERROR, error, failedCount});
                });
        }
        return next(action);
    }

    //subscribe to race updates topics
    function subscribeToRaceUpdates(store, next, action) {
        if (hasFeature("push-fast-results") && action.type === HORSE_RACE_UPDATE_SUBSCRIBE) {
            const state = store.getState();
            const oldTopics = state.horseRacing ? state.horseRacing.raceUpdate.subscribedTopics : [];
            const newTopics = createTopicPaths(action.countryGroups, notificationTopic);
            if (action.unsubscribe && oldTopics && oldTopics.length > 0) {            
                // Unsubscribe from the old topics
                unsubscribe(oldTopics)
                    .then(() => {
                        //grab topic stored from api
                        return fetchFrWssDetailsFromApi()
                    })
                    .then(details => {
                        const { topic } = details
                        //create new cg topic groups
                        const topics = createTopicPaths(action.countryGroups, topic)
                        // Subscribe to the new topics 
                        store.dispatch({ type: HORSE_RACE_UPDATE_UNSUBSCRIBE_SUCCESS });                  
                        return subscribe(topics, QUALITY_OF_SERVICE);
                    })
                    .then(confirmed => {
                        const confirmedTopics = confirmed.map(c => c.topic);
                        return next({type: HORSE_RACE_UPDATE_SUBSCRIBED, data: confirmedTopics});
                    })
                    .catch(error => {
                        return next({type: HORSE_RACE_UPDATE_SUBSCRIBE_ERROR, error});
                    });
            } else {
                
                fetchFrWssDetailsFromApi()
                    .then(details => {
                        const { topic } = details
                        const topics = createTopicPaths(action.countryGroups, topic)
                        // Subscribe to the new topics
                        return subscribe(topics, QUALITY_OF_SERVICE)
                    })
                    .then(() => {
                        return next({type: HORSE_RACE_UPDATE_SUBSCRIBED})
                    })
                    .catch(error => {
                        return next({type: HORSE_RACE_UPDATE_SUBSCRIBE_ERROR, error})
                    })
            }
        }
        return next(action); 
    }

    //Unsubscribe from a topic and kill connection. 
    function unsubscribeFromRaceUpdates(store, next, action) {
        if (action.type === HORSE_RACE_UPDATE_DISCONNECTING) {
            store.dispatch({type: HORSE_RACE_UPDATE_UNSUBSCRIBE});
        }
        
        if(action.type === HORSE_RACE_UPDATE_UNSUBSCRIBE || action.type === APPBRIDGE_SLEEP) {
            const state = store.getState();
            const {
                horseRacing: {
                    raceUpdate: {
                        subscribedTopics = []
                    } = {}
                } = {}
            } = state;
    
            if (subscribedTopics && subscribedTopics.length > 0) {
                unsubscribe(subscribedTopics)
                    .then(() => {
                        //kill client as its only valid for fast resutls at present
                        return closeClient();
                    })
                    .then(() => {
                        return next({type: HORSE_RACE_UPDATE_DISCONNECTED})
                    })
                    .catch(error => {
                        return next({type: HORSE_RACE_UPDATE_UNSUBSCRIBE_ERROR, error})
                    });
            } else {
                closeClient().then(() => {
                    return next({type: HORSE_RACE_UPDATE_UNSUBSCRIBE_SUCCESS})
                })
                .catch(error => {
                    closeClient();
                    return next({type: HORSE_RACE_UPDATE_UNSUBSCRIBE_ERROR, error})
                });
            }
        }
        return next(action);
    }


    //Failed connection retry with back off delay & fallback to polling action trigger 
    function failedRaceUpdateConnection(store, next, action) {
        if (hasFeature("push-fast-results") && action.type === HORSE_RACE_UPDATE_CONNECT_ERROR) {
            const state = store.getState();
            const failedAttempts = state.horseRacing.raceUpdate.failedSubscriptionAttempts;
            if (failedAttempts >= MAX_CONNECTION_ATTEMPTS) {
                return next({type: HORSE_RACE_UPDATE_FALLBACK_TO_POLLING});
            }
    
            setTimeout(() => {
                if (!state.horseRacing.raceUpdate.intentionalMqttClose) {
                    store.dispatch({type: HORSE_RACE_UPDATE_CONNECT});
                }
            }, RECONNECT_DELAY * failedAttempts);
        }
    
        return next(action);
    }
}

//fetches and holds wss details from the supplied api client
function getWssDetailsFromApi(apiClient, url) {
    let details = null
    return (refresh = false) => {
        if (details && !refresh) {
            return Promise.resolve(details)
        }
        return apiClient.get(url)
            .then(result => {
                const { wss_url = "", topics:{ fast_results:topic = null } } = result
                if (!wss_url) {
                    return Promise.reject('wss url is missing')
                }
                if (!topic) {
                    return Promise.reject('unable to find topic for fast results')
                }
                details = { topic, wssUrl: wss_url}
                return details
            })
    }
}

//hydrate a topic pattern with country groups
function createTopicPaths(countryGroups = DEFAULT_COUNTRY_GROUPS, topicPattern) {
    countryGroups = countryGroups.length > 0 ? countryGroups : DEFAULT_COUNTRY_GROUPS
    const topics = countryGroups.map(g => {
        return topicPattern
            .replace('${countryGroup}', g)
            .replace(/\${[a-zA-Z0-9]+}/g, '+')
    });
    return topics;
}


// WEBPACK FOOTER //
// ./modules/HorseRacing/middleware/raceUpdate.js